import main from '@/machines/main'
import App from '@/components/MachineWrapper.vue'

main({
    App,
    centralLandingAlias: 'Gemini200',
    trackingLabel: 'Gemini 200',
    sectionTrackingLabels: {
        description: 'Machine description',
        testimonials: 'Testimonials',
        specifications: 'Services',
        assistance: 'Video',
        coffee: 'Coffee',
        business: 'Business',
        accessories: 'Accessories',
        highlight: 'Highlight',
        trial: 'Contact Us'
    }
})
